module.exports = __webpack_public_path__ + "img/markIcon.a9bd6c8f.png";